// extracted by mini-css-extract-plugin
export default {"ImageWithOverlay":"ImageWithOverlay_ImageWithOverlay__1q3cI","ImageOverlay":"ImageWithOverlay_ImageOverlay__j8+Kp"};